module.exports = __webpack_public_path__ + "img/code.20ba5728.svg";